import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "@apollo/client";
import CircularProgress from "@mui/material/CircularProgress";
import ErrorScreen from "core/components/ErrorScreen";
import { DocumentQuery } from "site/queries";
import NoMatchScreen from "site/components/NoMatchScreen";
import DocumentBody from "site/components/DocumentBody";
import { useParams } from "react-router-dom";

export default function Document({ host }) {
  const { slug } = useParams();

  const { data, loading, error } = useQuery(DocumentQuery, {
    variables: { slug },
  });

  const document = data?.document;

  if (error) {
    return <ErrorScreen error={error} />;
  }

  if (loading) {
    return <CircularProgress />;
  }

  if (!document && !loading) {
    return <NoMatchScreen />;
  }

  const ott = host.includes(process.env.RAZZLE_SPRINTTY_BASE_DOMAIN);

  return <DocumentBody document={document} ott={ott} />;
}

Document.propTypes = {
  host: PropTypes.string.isRequired,
};
